import TextField from "../../../../components/fields/textField/TextField.vue";
import ConfirmPasswordDialog from "../../../../components/dialog/confirmPassword/ConfirmPasswordDialog.vue";
import CargoService from "../../../../services/CargoService.js";
import FormDialog from "../../../../components/dialog/form/FormDialog.vue";
import { AssinaturaMixin } from "@/mixins/assinaturaMixin";
import { SnackbarMixin } from "@/mixins/snackbarMixin";
import {SnackBarModule} from "@/modules/SnackBarModule";


export default {
    name: "DialogPerfilCargos",
    components: {
        TextField,
        ConfirmPasswordDialog,
        FormDialog,
        SnackBarModule
    },
    mixins:[AssinaturaMixin,SnackbarMixin ],
    props: {
        activeDialog: {
            type: Boolean,
            default: false,
        },
        perfilid: {
            required: true,
        }
    },
    data: () => ({
        headersCargo: [
            { text: "Cargo", value: "nome", sortable: false },
            { text: "", value: "atribuir", sortable: false, width: "100" },
        ],
        data: [],
        errors: [],
        disabled: {
            nome: false,
            cargos: false,
            cargos_perfil:false
        },
        form: {},
        formValid: true,
        loading: {
            table: false,
            table_cargos:false,
            btnsave:false
        },
        page_cargo: 1,
        pageCount_cargo: 0,
        itemsPerPage: 10,
        search: "",
        showFormDialog: false,
        activeBtnDialog:false,
        showDialogConfirmPassword: false,
        formConfirmPassword: {
            justificativa:"",
            password:""
        },
        send: {
            function: () => {},
            params: null,
        },

        cargos_perfil: [],
    }),

    watch: {
        activeDialog() {
            if (this.perfilid) {
                this.showFormDialog = !this.showFormDialog;
                this.initializeForm();
                this.getEditData();
            }
        },
    },

    created() {
        this.initializeForm();
        this.getCargos();

    },

    methods: {
        goTo(path) {
            this.$router.push(path);
        },

        updateCargosSavePerfil() {
            this.loading.btnsave = true;
            //verficar se tem ao menos 1
            const response = CargoService.getCargosByPerfilId(
                this.perfilid
            );

            response.then((res) => {
                if(res.content.response.length == 0) {
                    SnackBarModule("Você deve atribuir ao menos 1 cargo para esse perfil","error")

                } else {
                    this.showFormDialog = !this.showFormDialog;
                }
                this.loading.btnsave = false;
            })
            //

        },
        async getEditData() {
            this.page_cargo = 1;

            this.disabled.cargos_perfil = true;
            const response = CargoService.getCargosByPerfilId(
                this.perfilid,
            );
            response.then((res) => {
                if(typeof res.content.response == 'string'){
                    return this.disabled.cargos_perfil = false;

                }
                this.form.cargo_id = res.content.response.map(
                    (cargos_perfil) => cargos_perfil.cargo_id,
                );

                this.form.arrayCargosPerfil = this.form.cargo_id.slice();

                this.disabled.cargos_perfil = false;
            })
          /*  console.log(response)
            this.form.cargo_id = response.map(
                (cargo) => cargo.cargo_id,
            );

            this.form.arrayCargos = this.form.cargo_id.slice();

            this.disabled.cagos = false;*/
        },
        async getCargos() {

            this.disabled.cargos_perfil = true;
            const response = CargoService.getCargos();
            response.then((res) => {
                this.disabled.cargos_perfil = false;
                this.cargos_perfil = res.content.response;
            })


        },


        async selectCargo(cargo) {
            this.loading.table_cargos = true;

            const ret = await CargoService.addCargoPerfil({
                cargo_id:cargo,
                id_perfil:this.perfilid
            })
            ret.message.then((res) => {
                console.log(res)
                SnackBarModule('Atualizado com sucesso!',"success")
                this.loading.table_cargos = false;
            })
        },
        initializeForm() {
            this.form = {
                cargo_id: [],
                arrayCargosPerfil: [],
            };
        },

        close() {
            console.log('fechado')
            this.$emit("on-close");
        },

        async save() {
            this.errors = [];

            console.log(this.form);

            let arrayRemovidos = [];
            let arrayAdicionados = [];

            arrayRemovidos = this.form.arrayCargosPerfil.filter(
                (cargo) =>
                    !this.form.cargo_id.includes(cargo),
            );

            arrayAdicionados = this.form.cargo_id.filter(
                (cargo) =>
                    !this.form.arrayCargosPerfil.includes(cargo),
            );

            let response = {};
            if (arrayRemovidos.length > 0) {
                response = await CargoService.removerCargoPerfil(
                    this.perfilid,
                    { cargo_id: arrayRemovidos },
                );
            }

            if (!response.error && arrayAdicionados.length > 0) {
                response = await CargoService.atribuirCargoPerfil(
                    this.perfilid,
                    { cargo_id: arrayAdicionados },
                );
            }
            SnackBarModule("As Cargos do perfil foram atualizadas com sucesso","success");
            if (!response.error) {
                SnackBarModule("As Cargos do perfil foram atualizadas com sucesso","success");
                this.showFormDialog = !this.showFormDialog;
            } else {
                const message = await response.response;
                SnackBarModule(message, "error");
                this.errors.push(message);
            }
        },
    },
};
